import * as React from "react";
import i18n from "i18n";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import {
  Input,
  TableRow,
  TableCell,
  Tooltip,
  IconButton,
} from "@material-ui/core";
import {
  Warning as WarningIcon,
  Error as ErrorIcon,
  Autorenew as AutorenewIcon,
  Delete,
  Done as DoneIcon,
  Create as CreateIcon,
  Close,
} from "@material-ui/icons";

import { CompositionStore } from "modules/composition/CompositionStore";

const TaskRows = (props) => {
  const {
    classes,
    item,
    textTotal,
    textUnit,
    rateTask,
    btnEdit,
    hasAlternativeCode,
    _reloadComponent,
  } = props;
  const [edit, setEdit] = useState(false);
  const [stateCoefficient, setStateCoefficient] = useState(
    item.data.coefficient
  );
  const [stateTextUnit, setStateTextUnit] = useState(textUnit);
  const [editCoefficient, setEditCoefficient] = useState(false);
  const [editUnitCost, seteUnitCost] = useState(false);
  const [editBtnEdit, seteEditBtnEdit] = useState(btnEdit);

  useEffect(() => {
    setStateCoefficient(item.data.coefficient);
    setStateTextUnit(textUnit);
    setEdit(false);
  }, [item]);

  useEffect(() => {
    seteEditBtnEdit(btnEdit);
  }, [btnEdit]);

  const editClickHandler = () => {
    props.alterarBtnEdit();
    setEdit(!edit);
  };

  const cancelEdit = () => {
    setStateCoefficient(item.data.coefficient);
    setStateTextUnit(textUnit);
    if (editCoefficient == true) setEditCoefficient(false);
    if (editUnitCost == true) seteUnitCost(false);
    setEdit(!edit);
    props.alterarBtnEdit();
  };

  const saveElementes = async () => {
    if (editCoefficient !== false || editUnitCost !== false) {
      await CompositionStore.setTaskById(
        item.data.file.id,
        item.id,
        rateTask,
        stateCoefficient,
        stateTextUnit,
        textTotal,
        editCoefficient,
        editUnitCost
      );
      _reloadComponent(); // Após o processamento do serviço a função é chamada para fazer o componente pai renderizar novamente
    }
    setEdit(!edit);
    setEditCoefficient(false);
    seteUnitCost(false);
    props.alterarBtnEdit();
  };

  // Função para salvar os dados ao precionar a tecla enter no teclado
  const keyPress = (e) => {
    if (e.charCode === 13) {
      saveElementes();
    }
  };

  const editInput = (value, type) => {
    if (type === "coefficient") {
      setStateCoefficient(value);
      setEditCoefficient(true);
    }
    if (type === "unitCost") {
      setStateTextUnit(value);
      seteUnitCost(true);
    }
  };

  function convertPointToComma(number: number): string {
    const parts = number.toString().split(".");

    let integerPart = parts[0];
    let decimalPart = parts[1] || "";

    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    decimalPart = decimalPart.replace(/0+$/, "");

    if (decimalPart.length > 0) {
      return `${integerPart},${decimalPart}`;
    }
    return `${integerPart},00`;
  }
  return (
    <>
      <TableRow className={classes.task}>
        <TableCell className={classes.taskCell}>{item.data.code}</TableCell>
        {hasAlternativeCode && (
          <TableCell className={classes.taskCell}>
            {item.data.alternativeCodeItem
              ? item.data.alternativeCodeItem
              : item.data.alternativeCodeComposition}
          </TableCell>
        )}
        <TableCell className={classes.taskCell} style={{ flex: 24 }}>
          {item.data.description.charAt(0).toUpperCase() +
            item.data.description.slice(1)}
        </TableCell>
        <TableCell className={classes.taskCell} numeric>
          {item.data.unity}
        </TableCell>
        <TableCell className={classes.taskCell} numeric>
          {!edit ? (
            <Tooltip title={item.data.coefficient} placement="top">
              <span>
                {parseFloat(stateCoefficient.replace(",", "."))
                  .toFixed(2)
                  .replace(".", ",")}
              </span>
            </Tooltip>
          ) : (
            <Input
              classes={{ input: classes.inputCell }}
              defaultValue={stateCoefficient}
              placeholder={i18n.rateLibraries.header.quantity}
              onChange={(e) => editInput(e.target.value, "coefficient")}
              onKeyPress={(e) => keyPress(e)}
            />
          )}
        </TableCell>
        <TableCell className={classes.taskCell} numeric>
          {item.data.type === "TASK" ? (
            <Link
              to={`${location.pathname}/task~${item.id}`}
              className={classes.taskLink}
              onClick={() => (CompositionStore.loading = false)}
            >
              {textUnit}
            </Link>
          ) : !edit ? (
            <Tooltip
              title={convertPointToComma(item.data.unityCost)}
              placement="top"
            >
              <span>{stateTextUnit} </span>
            </Tooltip>
          ) : (
            <Input
              classes={{ input: classes.inputCell }}
              defaultValue={stateTextUnit}
              placeholder={i18n.rateLibraries.header.unitCost}
              onChange={(e) => editInput(e.target.value, "unitCost")}
              onKeyPress={(e) => keyPress(e)}
            />
          )}
        </TableCell>
        <TableCell className={classes.taskCell} numeric>
          {textTotal}
        </TableCell>
        {!CompositionStore.benchComposition.data.publicLibrary && ( // Se o banco de composição for uma biblioteca publica ele exibe a colina de edição
          <TableCell
            className={classes.taskCell}
            style={{ textAlign: "right" }}
          >
            {!edit ? (
              <IconButton
                className={classes.buttons}
                aria-label="Edite"
                onClick={() => editClickHandler()}
                disabled={editBtnEdit}
              >
                <Tooltip title={i18n.editto}>
                  <CreateIcon className={classes.iconMenu} />
                </Tooltip>
              </IconButton>
            ) : (
              <>
                <IconButton
                  className={classes.buttons}
                  aria-label="Save"
                  onClick={() => saveElementes()}
                >
                  <Tooltip title={i18n.save}>
                    <DoneIcon
                      className={classes.iconMenu}
                      style={{ color: "#0E8755" }}
                    />
                  </Tooltip>
                </IconButton>
                <IconButton
                  className={classes.buttons}
                  aria-label="Cancel"
                  onClick={() => cancelEdit()}
                >
                  <Tooltip title={i18n.cancel}>
                    <Close
                      className={classes.iconMenu}
                      style={{ color: "#D73912" }}
                    />
                  </Tooltip>
                </IconButton>
              </>
            )}
          </TableCell>
        )}
      </TableRow>
    </>
  );
};

export default TaskRows;



// WEBPACK FOOTER //
// ./src/modules/composition/components/layouts/TaskRow.tsx